import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ReduxFatalityState, ReduxFatalityStateWithError } from '@/store/reduxFatality/types';

/**
 * This slice stores error caught in redux callbacks (reducers, middlewares, thunks, etc)
 * So that a AppCrashModal can be displayed to the user
 */
export const reduxFatalitySlice = createSlice({
  name: 'reduxFatality',
  initialState: { errorCaught: false } as ReduxFatalityState,

  reducers: {
    setError: (
      _,
      {
        payload: { errorMessage, errorStack, action },
      }: PayloadAction<Omit<ReduxFatalityStateWithError, 'errorCaught'>>,
    ) => ({
      errorCaught: true,
      errorMessage,
      errorStack,
      action,
    }),
  },
});
